export enum ToastType {
  INFORMATION = 'information',
  TEXT = 'text',
  SUCCESS = 'success',
  DANGER = 'danger',
}
